import { getLangCode } from "../config";
import { language } from "../config/constants";

export const getStripeLocale = () => {
  return language.stripeLocales[getLangCode()] || language.default;
};
